
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./react-toastify.cjs.production.min.js')
} else {
  module.exports = require('./react-toastify.cjs.development.js')
}



//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/react-toastify@6.2.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/react-toastify/dist/index.js
// module id = 6719
// module chunks = 0